import { Drawer } from '@material-ui/core';
import * as React from 'react';
import * as Forms from '../../../../components/form-elements/_index';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { StatusCode } from '../../../../utils/api';
import { AppUtils } from '../../../../utils/app-utils';
import { ContainerRead } from '../../../../transportation/models/containers/container-read';
import { UpdateContainerCustomsRequest } from '../../../../transportation/models/shipments/shipment-update-customs';
import { TransportationSvc } from '../../../../transportation/service';
import { ShipmentType } from '../../../../transportation/models/enums/shipment-type';

interface IProps {
    visible: boolean;
    onSuccess: any;
    onClose: any;
    container: ContainerRead|undefined;
}

export const ActionSetContainerCustoms = (props: IProps) => {

    const [service] = React.useState(new TransportationSvc());
    const [editContainer, setEditContainer] = React.useState(new ContainerRead());

    /**
     * Copy the container to local state for editing
     */
    React.useEffect(() => {
        if (props.visible && props.container) {    
            setEditContainer({...props.container});
        }
    }, [props.visible]);

    /**
     * Update the state of the asset based on the name and 
     * value being passed in
     * @param e The event object from the input
     */
    const handleChange = (e: any) => {
        const t : any = { ...editContainer } as ContainerRead;

        if (e.target.type === 'text') {
            t[e.target.name] = e.target.value;
        }
        else if (e.target.type === 'number') {
            t[e.target.name] = Number.parseInt(e.target.value, 10);
        }
        
        setEditContainer(t);
    };

    /**
     * Save the schedule back to the server, and if successful
     * close the flyout
     */
    const onSave = async () => {

        const request           = new UpdateContainerCustomsRequest();
        request.rowVersion      = props.container!.rowVersion;
        request.seal            = editContainer.seal;        
        request.tareWeight      = editContainer.tareWeight;
        request.loadedWeight    = editContainer.loadedWeight;
        request.unloadedWeight  = editContainer.unloadedWeight;
        
        const result = await service.setCustomsInfo(
            request,
            props.container!.id,
            ShipmentType.Container
        );

        if (result.status === StatusCode.Success) {
            setEditContainer(undefined as unknown as ContainerRead);
            props.onSuccess();
        }
    };

    /**
     * Cleanup our state and close
     */
    const onCleanup = () => {
        setEditContainer(undefined as unknown as ContainerRead);
        props.onClose();
    };

    return <Drawer
            anchor="right"
            onClose={ onCleanup }
            open={ props.visible }>
            {
                !AppUtils.IsEmpty(editContainer)                        
                    ? <div className="stop-action-drawer mini stop-action-container-customs">

                        <div className="row">
                            <div className="col-md-12">
                                <h1>Set Customs</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <Forms.TextInput
                                    id="container-seal-number"
                                    type="text"
                                    label="Seal Number"
                                    name="seal"
                                    value={ editContainer.seal === null ? '' : editContainer.seal }
                                    onChange={ handleChange }
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <Forms.TextInput
                                    id="container-tare"
                                    type="number"
                                    label="Tare Weight"
                                    name="tareWeight"
                                    value={ editContainer.tareWeight === null ? '' : editContainer.tareWeight }
                                    onChange={ handleChange }
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <Forms.TextInput
                                    id="container-loadedWeight"
                                    type="number"
                                    label="Loaded Weight"
                                    name="loadedWeight"
                                    value={ editContainer.loadedWeight === null ? '' : editContainer.loadedWeight }
                                    onChange={ handleChange }
                                />
                            </div>
                        </div>  

                        <div className="row">
                            <div className="col-12">
                                <Forms.TextInput
                                    id="container-unloadedWeight"
                                    type="number"
                                    label="Unloaded Weight"
                                    name="unloadedWeight"
                                    value={ editContainer.unloadedWeight === null ? '' : editContainer.unloadedWeight }
                                    onChange={ handleChange }
                                />
                            </div>
                        </div>  

                        <FlyoutSaveCancel
                            onSave={ onSave }
                            onCancel={ onCleanup }
                        />

                    </div>
                    : null
            }
        </Drawer>;
};
